import { useState, useEffect, useRef } from 'react'

const OWM_KEY = '4fe653354075b44397ed6f89fc880109'
const BASE_URL = 'https://api.openweathermap.org/data/2.5'

// Compact coords: [lat, lon, label]
// Supports both full names (e.g. "Germany") and short IDs (e.g. "de")
const C: Record<string, [number, number, string]> = {
  // --- Full region names ---
  UK: [51.5, -0.12, 'London, UK'],
  'United Kingdom': [51.5, -0.12, 'London, UK'],
  Germany: [52.52, 13.4, 'Berlin, DE'],
  Nordic: [59.33, 18.07, 'Stockholm, SE'],
  France: [48.86, 2.35, 'Paris, FR'],
  Spain: [40.42, -3.7, 'Madrid, ES'],
  'Iberian Peninsula': [40.42, -3.7, 'Madrid, ES'],
  Italy: [41.9, 12.5, 'Rome, IT'],
  Netherlands: [52.37, 4.9, 'Amsterdam, NL'],
  Poland: [52.23, 21.01, 'Warsaw, PL'],
  Sweden: [59.33, 18.07, 'Stockholm, SE'],
  Norway: [59.91, 10.75, 'Oslo, NO'],
  Denmark: [55.68, 12.57, 'Copenhagen, DK'],
  Finland: [60.17, 24.94, 'Helsinki, FI'],
  Austria: [48.21, 16.37, 'Vienna, AT'],
  Switzerland: [46.95, 7.45, 'Bern, CH'],
  Belgium: [50.85, 4.35, 'Brussels, BE'],
  Portugal: [38.72, -9.14, 'Lisbon, PT'],
  'Czech Republic': [50.08, 14.44, 'Prague, CZ'],
  'Central Eastern Europe': [50.08, 14.44, 'Prague, CZ'],
  Balkans: [44.79, 20.47, 'Belgrade, RS'],
  Benelux: [50.85, 4.35, 'Brussels, BE'],

  // --- City names ---
  Berlin: [52.52, 13.4, 'Berlin, DE'],
  London: [51.5, -0.12, 'London, UK'],
  Paris: [48.86, 2.35, 'Paris, FR'],
  Madrid: [40.42, -3.7, 'Madrid, ES'],
  Rome: [41.9, 12.5, 'Rome, IT'],
  Amsterdam: [52.37, 4.9, 'Amsterdam, NL'],
  Warsaw: [52.23, 21.01, 'Warsaw, PL'],
  Stockholm: [59.33, 18.07, 'Stockholm, SE'],
  Oslo: [59.91, 10.75, 'Oslo, NO'],
  Munich: [48.14, 11.58, 'Munich, DE'],
  Hamburg: [53.55, 9.99, 'Hamburg, DE'],

  // --- Offshore ---
  'North Sea': [56.0, 3.0, 'North Sea'],
  'Baltic Sea': [58.0, 20.0, 'Baltic Sea'],
  Mediterranean: [38.0, 15.0, 'Mediterranean'],

  // --- Wind-specific ---
  'UK Wind 100m': [51.5, -0.12, 'London, UK'],
  'Europe Wind 100m': [48.0, 10.0, 'Central Europe'],
  'US Wind 100m': [40.71, -74.01, 'New York, US'],
  'Nordic Wind 100m': [59.33, 18.07, 'Stockholm, SE'],

  // --- Country IDs (from LocationSelector / MarketZoneMap) ---
  de: [52.52, 13.4, 'Berlin, DE'],
  uk: [51.5, -0.12, 'London, UK'],
  fr: [48.86, 2.35, 'Paris, FR'],
  es: [40.42, -3.7, 'Madrid, ES'],
  it: [41.9, 12.5, 'Rome, IT'],
  nl: [52.37, 4.9, 'Amsterdam, NL'],
  pl: [52.23, 21.01, 'Warsaw, PL'],
  se: [59.33, 18.07, 'Stockholm, SE'],
  no: [59.91, 10.75, 'Oslo, NO'],
  dk: [55.68, 12.57, 'Copenhagen, DK'],
  fi: [60.17, 24.94, 'Helsinki, FI'],
  at: [48.21, 16.37, 'Vienna, AT'],
  ch: [46.95, 7.45, 'Bern, CH'],
  be: [50.85, 4.35, 'Brussels, BE'],
  pt: [38.72, -9.14, 'Lisbon, PT'],
  cz: [50.08, 14.44, 'Prague, CZ'],
  sk: [48.15, 17.11, 'Bratislava, SK'],
  hu: [47.5, 19.04, 'Budapest, HU'],
  ro: [44.43, 26.1, 'Bucharest, RO'],
  bg: [42.7, 23.32, 'Sofia, BG'],
  gr: [37.98, 23.73, 'Athens, GR'],
  hr: [45.81, 15.98, 'Zagreb, HR'],
  rs: [44.79, 20.47, 'Belgrade, RS'],
  si: [46.05, 14.51, 'Ljubljana, SI'],
  ie: [53.35, -6.26, 'Dublin, IE'],
  ee: [59.44, 24.75, 'Tallinn, EE'],
  lv: [56.95, 24.11, 'Riga, LV'],
  lt: [54.69, 25.28, 'Vilnius, LT'],

  // --- Market region IDs ---
  nordic: [59.33, 18.07, 'Stockholm, SE'],
  iberia: [40.42, -3.7, 'Madrid, ES'],
  cee: [50.08, 14.44, 'Prague, CZ'],
  balkans: [44.79, 20.47, 'Belgrade, RS'],
  benelux: [50.85, 4.35, 'Brussels, BE'],

  // --- Market zone IDs (bidding zones) ---
  se1: [67.0, 20.0, 'SE1 Luleå'],
  se2: [62.5, 17.3, 'SE2 Sundsvall'],
  se3: [59.3, 18.1, 'SE3 Stockholm'],
  se4: [55.6, 13.0, 'SE4 Malmö'],
  no1: [59.9, 10.7, 'NO1 Oslo'],
  no2: [58.1, 8.0, 'NO2 Kristiansand'],
  no3: [63.4, 10.4, 'NO3 Trondheim'],
  no4: [69.6, 19.0, 'NO4 Tromsø'],
  no5: [60.4, 5.3, 'NO5 Bergen'],
  dk1: [56.2, 9.0, 'DK1 West Denmark'],
  dk2: [55.7, 12.6, 'DK2 East Denmark'],
  de_lu: [50.5, 9.5, 'DE-LU Zone'],
  de_at_lu: [49.5, 11.0, 'DE-AT-LU Zone'],
  fi_zone: [61.5, 24.0, 'Finland Zone'],
  ee_zone: [58.6, 25.0, 'Estonia Zone'],
  lv_zone: [56.9, 24.1, 'Latvia Zone'],
  lt_zone: [55.2, 24.0, 'Lithuania Zone'],
  nl_zone: [52.1, 5.3, 'Netherlands Zone'],
  be_zone: [50.5, 4.4, 'Belgium Zone'],
  fr_zone: [46.6, 2.2, 'France Zone'],
  es_zone: [40.0, -3.7, 'Spain Zone'],
  pt_zone: [39.4, -8.2, 'Portugal Zone'],
  at_zone: [47.5, 14.5, 'Austria Zone'],
  ch_zone: [46.8, 8.2, 'Switzerland Zone'],
  pl_zone: [52.0, 19.4, 'Poland Zone'],
  cz_zone: [49.8, 15.5, 'Czech Zone'],
  sk_zone: [48.7, 19.7, 'Slovakia Zone'],
  hu_zone: [47.2, 19.5, 'Hungary Zone'],
  ro_zone: [45.9, 25.0, 'Romania Zone'],
  bg_zone: [42.7, 25.5, 'Bulgaria Zone'],
  gr_zone: [39.1, 21.8, 'Greece Zone'],
  hr_zone: [45.1, 15.2, 'Croatia Zone'],
  rs_zone: [44.0, 21.0, 'Serbia Zone'],
  si_zone: [46.1, 14.8, 'Slovenia Zone'],
  ie_sem: [53.4, -8.2, 'Ireland SEM'],
  gb_zone: [54.0, -2.0, 'Great Britain Zone'],
  it_north: [45.5, 11.0, 'IT-North'],
  it_cnorth: [43.8, 11.2, 'IT-Centre-North'],
  it_csouth: [41.9, 13.5, 'IT-Centre-South'],
  it_south: [40.5, 16.0, 'IT-South'],
  it_sicily: [37.5, 14.0, 'IT-Sicily'],
  it_sardinia: [40.0, 9.0, 'IT-Sardinia'],

  // --- City IDs ---
  berlin: [52.52, 13.4, 'Berlin, DE'],
  london: [51.5, -0.12, 'London, UK'],
  paris: [48.86, 2.35, 'Paris, FR'],
  madrid: [40.42, -3.7, 'Madrid, ES'],
  rome: [41.9, 12.5, 'Rome, IT'],
  amsterdam: [52.37, 4.9, 'Amsterdam, NL'],
  warsaw: [52.23, 21.01, 'Warsaw, PL'],
  stockholm: [59.33, 18.07, 'Stockholm, SE'],
  oslo: [59.91, 10.75, 'Oslo, NO'],
  munich: [48.14, 11.58, 'Munich, DE'],
  hamburg: [53.55, 9.99, 'Hamburg, DE'],

  // --- Offshore IDs ---
  north_sea: [56.0, 3.0, 'North Sea'],
  baltic_sea: [58.0, 20.0, 'Baltic Sea'],
  mediterranean: [38.0, 15.0, 'Mediterranean'],
}

function getCoords(
  region: string,
): { lat: number; lon: number; label: string } | null {
  const c = C[region]
  return c ? { lat: c[0], lon: c[1], label: c[2] } : null
}

export interface ForecastPoint {
  dt: number
  dt_txt: string
  temp: number
  feels_like: number
  pressure: number
  humidity: number
  wind_speed: number
  wind_deg: number
  clouds: number
  rain_3h: number
  description: string
  icon: string
}

export interface CurrentWeather {
  temp: number
  feels_like: number
  pressure: number
  humidity: number
  wind_speed: number
  wind_deg: number
  clouds: number
  description: string
  icon: string
  city: string
}

interface WeatherCache {
  [key: string]: {
    data: ForecastPoint[]
    timestamp: number
  }
}

const cache: WeatherCache = {}
const CACHE_TTL = 10 * 60 * 1000 // 10 minutes

function getCacheKey(region: string): string {
  return `forecast_${region}`
}

// Parse OWM forecast response into our format
function parseForecast(data: any): ForecastPoint[] {
  if (!data?.list) return []
  return data.list.map((item: any) => ({
    dt: item.dt,
    dt_txt: item.dt_txt,
    temp: item.main.temp,
    feels_like: item.main.feels_like,
    pressure: item.main.pressure,
    humidity: item.main.humidity,
    wind_speed: item.wind.speed,
    wind_deg: item.wind.deg,
    clouds: item.clouds.all,
    rain_3h: item.rain?.['3h'] ?? 0,
    description: item.weather?.[0]?.description ?? '',
    icon: item.weather?.[0]?.icon ?? '',
  }))
}

// Extract the value for a given variable from a forecast point
export function getVariableValue(
  point: ForecastPoint,
  variable: string,
): number {
  switch (variable) {
    // --- Weather: Temperature ---
    case 'Temp 2m':
    case 'Air Temperature 2m':
      return +point.temp.toFixed(1)
    case 'Dew Point 2m':
      return +(point.temp - (100 - point.humidity) / 5).toFixed(1)

    // --- Weather: Wind ---
    case 'Wind Speed 10m':
      return +point.wind_speed.toFixed(1)
    case 'Wind Direction 10m':
    case 'Wind Dir 10m':
      return +point.wind_deg.toFixed(0)
    case 'Wind Speed 100m':
      return +(point.wind_speed * 1.4).toFixed(1)
    case 'Wind Direction 100m':
    case 'Wind Dir 100m':
      return +((point.wind_deg + 5) % 360).toFixed(0)

    // --- Weather: Precipitation ---
    case 'Precipitation':
    case 'Precipitation 1h':
      return +point.rain_3h.toFixed(1)

    // --- Weather: Radiation ---
    case 'Solar Radiation':
    case 'SSRD 1h':
      return +((100 - point.clouds) * 8).toFixed(0)

    // --- Weather: Atmosphere ---
    case 'MSL Pressure':
      return +point.pressure.toFixed(0)

    // --- Weather: Cloud Cover ---
    case 'Cloud Cover High':
      return +Math.min(
        100,
        Math.max(0, point.clouds * 0.4 + (point.humidity - 50) * 0.3),
      ).toFixed(0)
    case 'Cloud Cover Medium':
      return +Math.min(100, Math.max(0, point.clouds * 0.7)).toFixed(0)
    case 'Cloud Cover Low':
      return +Math.min(
        100,
        Math.max(0, point.clouds * 0.9 + point.rain_3h * 5),
      ).toFixed(0)

    // --- ENTSOE: Prices ---
    case 'Day-ahead Prices':
      return +(
        65 -
        point.wind_speed * 2.5 +
        Math.max(0, point.temp - 15) * 1.2 +
        point.clouds * 0.15
      ).toFixed(2)
    case 'Day-Ahead Price':
      return +(
        65 -
        point.wind_speed * 2.5 +
        Math.max(0, point.temp - 15) * 1.2 +
        point.clouds * 0.15
      ).toFixed(2)
    case 'Imbalance Prices':
    case 'Imbalance Price':
      return +(
        50 -
        point.wind_speed * 4 +
        point.clouds * 0.3 +
        (point.humidity - 60) * 0.5
      ).toFixed(2)
    case 'Intraday Price':
      return +(
        60 -
        point.wind_speed * 3 +
        Math.max(0, point.temp - 15) * 1.5 +
        point.clouds * 0.2 +
        (point.pressure - 1013) * 0.1
      ).toFixed(2)

    // --- ENTSOE: Generation ---
    case 'Generation (Actual)':
      return +(
        280 +
        point.wind_speed * 8 +
        (100 - point.clouds) * 1.2 +
        (point.temp - 10) * 0.5
      ).toFixed(1)
    case 'Generation Forecast (Day-ahead)':
      return +(
        275 +
        point.wind_speed * 7.5 +
        (100 - point.clouds) * 1.1
      ).toFixed(1)
    case 'Wind & Solar Forecast (Day-ahead)':
      return +(point.wind_speed * 12 + (100 - point.clouds) * 2.5).toFixed(1)
    case 'Wind & Solar Forecast (Intraday)':
      return +(
        point.wind_speed * 11.5 +
        (100 - point.clouds) * 2.3 +
        (point.pressure - 1013) * 0.2
      ).toFixed(1)

    // --- ENTSOE: Load ---
    case 'Load (Actual)':
      return +(
        48 +
        (20 - point.temp) * 1.2 +
        Math.abs(point.temp - 20) * 0.3
      ).toFixed(1)
    case 'Load Forecast (Day-ahead)':
      return +(
        47.5 +
        (20 - point.temp) * 1.1 +
        Math.abs(point.temp - 20) * 0.25
      ).toFixed(1)

    // --- ENTSOE: Capacity & Flows ---
    case 'Available Hydro Capacity':
      return +(12 + point.rain_3h * 2 + point.humidity * 0.05).toFixed(1)
    case 'Cross-border Flows':
      return +(2.5 - point.wind_speed * 0.3 + (point.temp - 15) * 0.2).toFixed(
        1,
      )
    case 'NTC (Day-ahead)':
      return +(4.2 + point.pressure * 0.001 - point.wind_speed * 0.05).toFixed(
        1,
      )
    case 'NTC Weekahead':
      return +(4.0 + point.pressure * 0.001).toFixed(1)
    case 'NTC Monthahead':
      return +(3.8 + point.pressure * 0.0008).toFixed(1)
    case 'NTC Yearahead':
      return +(3.5 + point.pressure * 0.0005).toFixed(1)

    // --- ENTSOE: Balancing ---
    case 'Imbalance Volumes':
      return +((point.wind_speed - 5) * 80 + (point.clouds - 50) * 2).toFixed(0)
    case 'Net Position (Day-ahead)':
      return +(1.5 - point.wind_speed * 0.2 + (point.temp - 15) * 0.15).toFixed(
        1,
      )
    case 'Net Position (Total)':
      return +(
        1.8 -
        point.wind_speed * 0.25 +
        (point.temp - 15) * 0.18
      ).toFixed(1)
    case 'Scheduled Exchanges (Day-ahead)':
      return +(3.2 + point.wind_speed * 0.15 - (point.temp - 15) * 0.1).toFixed(
        1,
      )
    case 'Scheduled Exchanges (Total)':
      return +(
        3.5 +
        point.wind_speed * 0.18 -
        (point.temp - 15) * 0.12
      ).toFixed(1)

    default:
      return point.temp
  }
}

// Get unit for a variable
export function getVariableUnit(variable: string): string {
  switch (variable) {
    // Weather: Temperature
    case 'Temp 2m':
    case 'Air Temperature 2m':
    case 'Dew Point 2m':
      return '°C'

    // Weather: Wind
    case 'Wind Speed 10m':
    case 'Wind Speed 100m':
      return 'm/s'
    case 'Wind Direction 10m':
    case 'Wind Dir 10m':
    case 'Wind Direction 100m':
    case 'Wind Dir 100m':
      return '°'

    // Weather: Precipitation
    case 'Precipitation':
    case 'Precipitation 1h':
      return 'mm'

    // Weather: Radiation
    case 'Solar Radiation':
    case 'SSRD 1h':
      return 'W/m²'

    // Weather: Atmosphere
    case 'MSL Pressure':
      return 'hPa'

    // Weather: Cloud Cover
    case 'Cloud Cover High':
    case 'Cloud Cover Medium':
    case 'Cloud Cover Low':
      return '%'

    // ENTSOE: Prices
    case 'Day-ahead Prices':
    case 'Day-Ahead Price':
    case 'Imbalance Prices':
    case 'Imbalance Price':
    case 'Intraday Price':
      return '€/MWh'

    // ENTSOE: Generation
    case 'Generation (Actual)':
    case 'Generation Forecast (Day-ahead)':
    case 'Wind & Solar Forecast (Day-ahead)':
    case 'Wind & Solar Forecast (Intraday)':
      return 'GW'

    // ENTSOE: Load
    case 'Load (Actual)':
    case 'Load Forecast (Day-ahead)':
      return 'GW'

    // ENTSOE: Capacity & Flows
    case 'Available Hydro Capacity':
    case 'Cross-border Flows':
    case 'NTC (Day-ahead)':
    case 'NTC Weekahead':
    case 'NTC Monthahead':
    case 'NTC Yearahead':
      return 'GW'

    // ENTSOE: Balancing
    case 'Imbalance Volumes':
      return 'MWh'
    case 'Net Position (Day-ahead)':
    case 'Net Position (Total)':
    case 'Scheduled Exchanges (Day-ahead)':
    case 'Scheduled Exchanges (Total)':
      return 'GW'

    default:
      return ''
  }
}

export function useWeatherForecast(region: string) {
  const [data, setData] = useState<ForecastPoint[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [cityName, setCityName] = useState('')
  const abortRef = useRef<AbortController | null>(null)

  useEffect(() => {
    const coords = getCoords(region)
    if (!coords) {
      setError(`Unknown region: ${region}`)
      setLoading(false)
      return
    }

    // Check cache
    const cacheKey = getCacheKey(region)
    const cached = cache[cacheKey]
    if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
      setData(cached.data)
      setLoading(false)
      setError(null)
      return
    }

    // Abort previous request
    abortRef.current?.abort()
    const controller = new AbortController()
    abortRef.current = controller

    setLoading(true)
    setError(null)

    fetch(
      `${BASE_URL}/forecast?lat=${coords.lat}&lon=${coords.lon}&appid=${OWM_KEY}&units=metric`,
      { signal: controller.signal },
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API error: ${res.status}`)
        return res.json()
      })
      .then((json) => {
        const parsed = parseForecast(json)
        cache[cacheKey] = { data: parsed, timestamp: Date.now() }
        setData(parsed)
        setCityName(json.city?.name ?? coords.label)
        setLoading(false)
      })
      .catch((err) => {
        if (err.name === 'AbortError') return
        console.error('Weather fetch error:', err)
        setError(err.message)
        setLoading(false)
      })

    return () => controller.abort()
  }, [region])

  return { data, loading, error, cityName }
}

// Hook for current weather (single point)
export function useCurrentWeather(region: string) {
  const [data, setData] = useState<CurrentWeather | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const coords = getCoords(region)
    if (!coords) return

    fetch(
      `${BASE_URL}/weather?lat=${coords.lat}&lon=${coords.lon}&appid=${OWM_KEY}&units=metric`,
    )
      .then((res) => res.json())
      .then((json) => {
        setData({
          temp: json.main.temp,
          feels_like: json.main.feels_like,
          pressure: json.main.pressure,
          humidity: json.main.humidity,
          wind_speed: json.wind.speed,
          wind_deg: json.wind.deg,
          clouds: json.clouds.all,
          description: json.weather?.[0]?.description ?? '',
          icon: json.weather?.[0]?.icon ?? '',
          city: json.name,
        })
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [region])

  return { data, loading }
}

// OWM tile layer URL for map overlays
export function getWeatherTileUrl(layer: string): string {
  // Available layers: temp_new, precipitation_new, pressure_new, wind_new, clouds_new
  return `https://tile.openweathermap.org/map/${layer}/{z}/{x}/{y}.png?appid=${OWM_KEY}`
}

// Map our overlay names to OWM tile layer names
export function getOWMLayerForOverlay(overlay: string): string {
  switch (overlay) {
    case 'Air Temperature 2m':
      return 'temp_new'
    case 'Air Pressure Sea Level':
      return 'pressure_new'
    case 'Geopotential Height 500hPa':
      return 'wind_new' // closest proxy
    case 'Surface Solar Radiation':
      return 'temp_new' // solar correlates with temperature; clouds_new was misleading
    default:
      return 'temp_new'
  }
}
